const metrics = new Map();

export const recordAd2Metric = (name, value = 1) => {
  const current = metrics.get(name) || { count: 0, total: 0, max: 0 };
  current.count += 1;
  current.total += Number(value) || 0;
  current.max = Math.max(current.max, Number(value) || 0);
  metrics.set(name, current);
  if (process.env.REACT_APP_AD2_METRICS === 'true' && current.count % 25 === 0) {
    console.info('[ad2-metrics]', name, { ...current });
  }
};

export const getAd2Metrics = () => Object.fromEntries(
  [...metrics.entries()].map(([name, value]) => [name, { ...value }]),
);

export const resetAd2Metrics = () => metrics.clear();
